import Vue from 'vue'
import Vuex from 'vuex'
import * as apiService from '@/services/apiService'
import {T_LANG} from '@/config/AppConfig'

Vue.use(Vuex)

function returnCategoryDescriptionArray(categories) {
  const categoryDescriptionArray = {}

  function filterDescriptions(category) {
    if (category.description) {
      categoryDescriptionArray[category.id] = category.description
    }
    if (category.children) {
      category.children.forEach(child => filterDescriptions(child))
    }
  }

  categories.forEach((category) => {
    filterDescriptions(category)
  })

  return categoryDescriptionArray
}

function partition(array, filter) {
  let pass = [], fail = [];
  array.forEach((e, idx, arr) => (filter(e, idx, arr) ? pass : fail).push(e));
  return [pass, fail];
}

function findIfShopIsInSelectedCategories(shopCategories, selectedCategories) {
  if (selectedCategories.length === 0) return true

  let bool = false
  for (let category of shopCategories) {
    if (selectedCategories.includes(category)) {
      bool = true;
      break;
    }
  }

  return bool
}

function filterShopsAlphabetically(shopName, selectedAlphabeticalFilter) {
  if (!selectedAlphabeticalFilter) return true
  return [...selectedAlphabeticalFilter].includes(shopName.charAt(0).toLowerCase())
}

export const store = new Vuex.Store({
  state: {
    orderBy: null,
    str: '',
    selectedCategories: [],
    categories: [],
    items: [],
    filters: {
      alphabetical: null
    },
    categoryDescriptionList: null
  },
  getters: {
    getStoreVar: (state) => (key) => {
      return state[key]
    },
    getFilteredStores: state => {
      return state.items.filter(shop => {
        return findIfShopIsInSelectedCategories(shop.categories, state.selectedCategories) && filterShopsAlphabetically(shop.name, state.filters.alphabetical)
      })
    },
    getAlphabeticalFilter: state => state.filters.alphabetical,
    getSelectedCategories: state => state.selectedCategories,
    getCategoryDescriptionList: state => state.categoryDescriptionList,
    getSearchQuery: state => state.str
  },
  mutations: {
    setStoreVar: (state, {key, data}) => {
      state[key] = data
    },
    SET_FILTER(state, payload) {
      if (state.filters[payload.key] && state.filters[payload.key] === payload.value) {
        state.filters[payload.key] = null
      } else {
        state.filters[payload.key] = payload.value
      }
    },
    SET_CATEGORY(state, categoryId) {
      let updatedCategories = [...state.selectedCategories]
      const index = updatedCategories.indexOf(categoryId)
      index >= 0 ?
        updatedCategories.splice(index, 1) :
        updatedCategories.push(categoryId)

      Vue.set(state, 'selectedCategories', updatedCategories)
    },
    REMOVE_CATEGORY(state, categoryId) {
      let updatedCategories = [...state.selectedCategories]
      const index = updatedCategories.indexOf(categoryId)
      updatedCategories.splice(index, 1)
      Vue.set(state, 'selectedCategories', updatedCategories)
    },
    CLEAR_FILTERS(state) {
      Vue.set(state, 'selectedCategories', [])
      Vue.set(state, 'filters', {alphabetical: null})
    },
    SET_CATEGORY_DESCRIPTION_LIST(state, data) {
      Vue.set(state, 'categoryDescriptionList', data)
    }
  },
  actions: {
    setStoreVar(context, {key, data}) {
      context.commit('setStoreVar', {key, data})
    },
    getCategories(context, requestData) {
      return new Promise((resolve, reject) => {
        let lang = T_LANG;
        // TEMPORARY
        apiService.makeApiCall('wp-json/fe/v1/stores/categories-tree?lang=' + lang, 'get')
          .then(response => {
            const categoryDescriptionList = returnCategoryDescriptionArray(response)
            context.commit('SET_CATEGORY_DESCRIPTION_LIST', categoryDescriptionList)
            context.commit('setStoreVar', {key: 'categories', data: response})
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getItems(context, requestData) {
      return new Promise((resolve, reject) => {
        let lang = T_LANG;
        // TEMPORARY
        apiService.makeApiCall('wp-json/fe/v1/stores/?lang=' + lang, 'get')
          .then(response => {
            let [pinnedShops, otherShops] = partition(response, e => e.pinned !== false)
            pinnedShops.sort((a, b) => a > b)
            otherShops.sort((a, b) => a.name.localeCompare(b.name))
            const allShops = pinnedShops.concat(otherShops)
            context.commit('setStoreVar', {key: 'items', data: allShops})
            resolve('ok')
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    setFilter({commit}, payload) {
      commit('SET_FILTER', payload)
    },
    setCategory({commit}, payload) {
      commit('SET_CATEGORY', payload)
    },
    removeCategory({commit}, payload) {
      commit('REMOVE_CATEGORY', payload)
    },
    clearFilters({commit}) {
      commit('CLEAR_FILTERS')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js